import { useEffect, useState } from "react";
import { api, getToken, setToken, type Me } from "./api";
import { Login } from "./Login";
import { Dashboard } from "./Dashboard";
import { I18nProvider, useTranslation } from "./i18n";

function AppInner() {
  const { t, setLocale } = useTranslation();
  const [me, setMe] = useState<Me | null>(null);
  const [bootError, setBootError] = useState<string | null>(null);
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    // A reset link must show the form even when this browser has a live session.
    if (new URLSearchParams(window.location.search).get("reset")) {
      setToken(null);
      setBooting(false);
      return;
    }
    if (!getToken()) {
      setBooting(false);
      return;
    }
    const inviteToken = new URLSearchParams(window.location.search).get("invite");
    api
      .me()
      .then(async (profile) => {
        let current = profile;
        if (inviteToken) {
          try {
            await api.acceptInvitation(inviteToken);
            current = await api.me();
            const url = new URL(window.location.href);
            url.searchParams.delete("invite");
            window.history.replaceState({}, "", url.toString());
          } catch (err: unknown) {
            setBootError(err instanceof Error ? err.message : String(err));
          }
        }
        setMe(current);
        if (current.preferred_language) {
          setLocale(current.preferred_language as any);
        }
      })
      .catch((err: Error) => {
        setBootError(err.message);
        setToken(null);
      })
      .finally(() => setBooting(false));
  }, []);

  if (booting) {
    return (
      <div className="app">
        <p className="muted">{t("generic.loading")}</p>
      </div>
    );
  }
  if (!me) {
    return (
      <Login
        onAuthenticated={async () => {
          setBootError(null);
          const profile = await api.me();
          setMe(profile);
        }}
      />
    );
  }
  return (
    <div className="app">
      <div className="header">
        <h1>{t("header.title")}</h1>
        <div className="flex">
          <span className="muted">{me.email}</span>
          <button
            className="btn"
            onClick={() => {
              setToken(null);
              setMe(null);
            }}
          >
            {t("header.signout")}
          </button>
        </div>
      </div>
      {bootError && <p className="error">{bootError}</p>}
      <Dashboard me={me} />
    </div>
  );
}

export function App() {
  return (
    <I18nProvider>
      <AppInner />
    </I18nProvider>
  );
}
